import { Flex, Spin } from "antd";
import { Suspense } from "react";
import { useTranslation } from "react-i18next";
import { NavLink, Outlet } from "react-router";

import { CustomerPageWrapper } from "../../CustomerPageWrapper";

import "./index.less";

export const UserSettingsLoader = () => (
  <Flex className="user-settings-page-loader" justify="center">
    <Spin />
  </Flex>
);

const UserSettingsPageWrapper = () => {
  const { t } = useTranslation();

  const links = [
    { href: "/explore/user/account", label: t("user.settings.account.label") },
    { href: "/explore/user/language", label: t("user.settings.language.label") },
    { href: "/explore/user/password", label: t("user.settings.password.label") },
    { href: "/explore/user/notifications", label: t("user.settings.notifications.label") },
    { href: "/explore/user/legal", label: t("user.settings.terms.label") },
  ];

  return (
    <CustomerPageWrapper title={t("user.settings.title")}>
      <div className="user-settings-page-wrapper">
        <div className="user-settings-page-links">
          {links.map((link, i) => (
            <div key={link.href}>
              <NavLink to={link.href} className={({ isActive }) => `user-settings-page-link ${isActive ? "user-settings-page-link-active" : ""}`}>
                {link.label}
              </NavLink>
              {i !== links.length - 1 && <span className="separator">&nbsp;&nbsp;&nbsp;&nbsp;|</span>}
            </div>
          ))}
        </div>
        <Suspense fallback={<UserSettingsLoader />}>
          <Outlet />
        </Suspense>
      </div>
    </CustomerPageWrapper>
  );
};

export default UserSettingsPageWrapper;
